export default __webpack_public_path__ + "static/SSM-SAFe4-66cf92ecef04a8414a62df45d5d24ac2.png";